import {get, post} from './fetch.js'

/*-- 老带新 --*/ 
export const referNew = (params) => post("/v1/invite-new/old", { shopify_shop_id: shopId, ...params })
export const referOld = (params) => post("/v1/invite-new/new", { shopify_shop_id: shopId, ...params })
/*-- 老带新 --*/ 


/*-- jackery life --*/
// 获取活动时间节点信息
export const getLifeActivityNodeTime = params => get("/life-api/api/consumer/getActivityDetail", { shopifyShopId: shopId, ...params })

// 获取活动排行榜信息
export const getLifeActivityRank = (params, settings) =>
    get("/life-api/api/consumer/getActivityCharts", { shopifyShopId: shopId, ...params, }, settings)

// 获取explore所有活动排行榜
export const getLifeExploreRank = params => get("/life-api/api/consumer/getAllCharts", { shopifyShopId: shopId, ...params })
/*-- jackery life --*/



/*-- stories 招募页 --*/ 
export const addStoriesRecruit = (params) => post("/osconsumerapi/cusumer/stories/join", { shopifyShopId: shopId, ...params })
/*-- stories 招募页 --*/ 


/*-- 报价单 --*/ 
export const quotation = (params) => post("/v1/order-quotation/subscribe", { shopify_shop_id: shopId, ...params })
/*-- 报价单 --*/ 

/*-- 报价单 view --*/ 
export const quotationPreview = (params) => post("/v1/order-quotation/preview", { ...params })
/*-- 报价单 view --*/ 


/*-- 报价单 download --*/ 
export const quotationExport = (token) => get(`/v1/export/file?token=${token}`)
/*-- 报价单 download --*/ 

/*-- 报价单 add --*/ 
export const quotationAdd = (params) => post("/v1/order-quotation/add", { ...params })
/*-- 报价单 add --*/ 


// 创建会员价优惠券
export const createMembershipPriceCoupon = params => post("/osconsumerapi/v1/active/create-coupon", params)
// 查询会员价活动产品
export const getMembershipPriceActiveProducts = params => post("/osconsumerapi/v1/active/index", params)
// 查询商详页会员价
export const getMembershipPriceProductInfo = params => post("/osconsumerapi/v1/active/product-member-benefit", params)
// 获取积分余额
export const getPointAccount = () => get('/userapi/v1/point/pointAccount')





// 老带新
// 老带新配置
export const getOldInviteNewConfig = () => get("/osconsumerapi/v1/old-invite-new/config", { shopifyShopId: shopId, })

// 获取老客推荐信息
export const getOldReferInfo = params => post("/osconsumerapi/v1/old-invite-new/older-info", { shopifyShopId: shopId, ...params })

// 生成推荐链接
export const createReferLink = params => post("/osconsumerapi/v1/old-invite-new/refer", { shopifyShopId: shopId, ...params })

// 发送老带新邮件
export const sendInviteEmail = params => post("/osconsumerapi/v1/old-invite-new/send-invite-email", { shopifyShopId: shopId, ...params })


// 获取新客订阅title
export const getOldInviteNewTitle = () => get("/osconsumerapi/v1/old-invite-new/title", { shopifyShopId: shopId, })

// 新客订阅接口
export const oldInviteNewSubscribe = (params) => post("/osconsumerapi/v1/old-invite-new/subscribe", { shopifyShopId: shopId, ...params })



// 捆绑销售
export const getProductBundledInfo = (params) => post("/osconsumerapi/v1/app-bundled-sale/info", { shopifyShopId: shopId, ...params })

// 产品优惠券
export const getProductCouponInfo = (params) => get("/osconsumerapi/v1/app-coupon/info", { shopifyShopId: shopId, ...params })
